import { useMemo } from "react"
import { UserModuleType } from "@tm/models"
import { useUser } from "../user"
import { getModuleFromUserContext, getParameterFromUserContextModule } from "../helper"

export function useOffersModules() {
    const { userContext } = useUser()

    return useMemo(() => {
        const offerCarouselModule = getModuleFromUserContext(userContext, UserModuleType.OfferCarousel)
        const offersModule = getModuleFromUserContext(userContext, UserModuleType.Offers)
        const offersModuleIntegration = getParameterFromUserContextModule(userContext, UserModuleType.Offers, "Integration")
        const offersTileView = getParameterFromUserContextModule(userContext, UserModuleType.Offers, "TileView")
        const offerCarouselTileView = userContext?.parameter.offerCarouselTileView
        const offerCarouselModuleDescription = offerCarouselModule?.parameters?.find((x) => x.key === "Description")?.value ?? "{{1276}}" // So the id can be seen in the browser
        const offersModuleDescription = offersModule?.parameters?.find((x) => x.key === "Description")?.value ?? "{{1276}}" // So the id can be seen in the browser

        return {
            hasOffersModuleEnabled: !!offersModule,
            hasOfferCarouselModuleEnabled: !!offerCarouselModule,
            hasOffersModuleTileView: !!offersTileView,
            hasOfferCarouselModuleTileView: !!offerCarouselTileView,
            offerCarouselModuleDescription,
            offersModuleDescription,
            offersModuleIntegration,
        }
    }, [userContext])
}
